import React, { Component } from "react";
import Modal from "react-modal";
import { BtnRound } from "../../_components/BtnRound";
import "./style.css";
Modal.setAppElement("#root");

// edit name to custom-header modal

class ModalSnjob extends Component {
  render() {
    const { children, title, className, isOpen, onClose } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        portalClassName="full_screen_modal"
        className={`ModalSnjob d-flex justify-content-center align-items-center h-100 ${className}`}
      >
        <div className="container mx-auto my-5 py-3 px-4 bg-white position-relative">
          {title !== undefined && (
            <div className="row">
              <div className="col-12 mx-auto mb-4 py-2 d-flex justify-content-center align-items-center bg-primary rounded-pill position-relative">
                <p className="title m-0 text-light iran-sans_Bold">{title}</p>
                <BtnRound
                  className="close-btn position-absolute"
                  style={{ borderRadius: "50%" }}
                  onClick={onClose}
                />
              </div>
            </div>
          )}
          {children}
        </div>
      </Modal>
    );
  }
}

export { ModalSnjob };
